@if (area()) {
    <div>
        <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
        {{ area() }}
    </div>
}
